// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShowOneTotalPrice-labelText-gtlIb {
    display: inline-block;
    font-weight: 500;
    margin: 0px;
    font-size: 14px;
}

.ShowOneTotalPrice-mapFlex-KZRX7 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-column-gap: 8px;
       -moz-column-gap: 8px;
            column-gap: 8px;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.ShowOneTotalPrice-ShowPricecurvedbox-nagi6 {
    width: 100%;
    max-width: 457px;
    margin: 0 auto;
    border: 1px solid var(--primary-border);
    border-radius: 27px;
    padding: 12px 12px 12px 24px;
    gap: 3px;
}

.ShowOneTotalPrice-totalDescriptiontext-Ld8be {
    color: var(--secondary-foreground);
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/Filters/ShowOneTotalPrice/ShowOneTotalPrice.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAAe;OAAf,oBAAe;YAAf,eAAe;IACf,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,mBAAmB;IACnB,4BAA4B;IAC5B,QAAQ;AACZ;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".labelText {\n    display: inline-block;\n    font-weight: 500;\n    margin: 0px;\n    font-size: 14px;\n}\n\n.mapFlex {\n    display: flex;\n    align-items: center;\n    column-gap: 8px;\n    justify-content: center;\n}\n\n.ShowPricecurvedbox {\n    width: 100%;\n    max-width: 457px;\n    margin: 0 auto;\n    border: 1px solid var(--primary-border);\n    border-radius: 27px;\n    padding: 12px 12px 12px 24px;\n    gap: 3px;\n}\n\n.totalDescriptiontext {\n    color: var(--secondary-foreground);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelText": `ShowOneTotalPrice-labelText-gtlIb`,
	"mapFlex": `ShowOneTotalPrice-mapFlex-KZRX7`,
	"ShowPricecurvedbox": `ShowOneTotalPrice-ShowPricecurvedbox-nagi6`,
	"totalDescriptiontext": `ShowOneTotalPrice-totalDescriptiontext-Ld8be`
};
module.exports = ___CSS_LOADER_EXPORT___;
